import { render, staticRenderFns } from "./VoteLoader.vue?vue&type=template&id=f520af24&scoped=true"
import script from "./VoteLoader.vue?vue&type=script&lang=js"
export * from "./VoteLoader.vue?vue&type=script&lang=js"
import style0 from "./VoteLoader.vue?vue&type=style&index=0&id=f520af24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f520af24",
  null
  
)

export default component.exports